const images = {
    logoWhite: require('~/assets/images/logo_white.svg').default,
    logoBlue: require('~/assets/images/logo_blue.svg').default,
    empty: require('~/assets/images/undraw_empty.svg').default,
    emptyBin: require('~/assets/images/undraw_empty_bin.svg').default,
    multitasking: require('~/assets/images/undraw_multitasking.svg').default,
    learning: require('~/assets/images/undraw_learning.svg').default,
    workingPage: require('~/assets/images/workingpage.svg').default,
    projectDone: require('~/assets/images/undraw_project_done.svg').default,
    toTheMoon: require('~/assets/images/undraw_to_the_moon.svg').default,
    pageNotFound: require('~/assets/images/undraw_page_not_found.svg').default,
    launching: require('~/assets/images/undraw_launching.svg').default,
    verified: require('~/assets/images/undraw_approve.svg').default,
}

export default images
